import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';

import LoadingComponent from '../../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';
import FrameFilters from './FrameFilters';
import FrameList from './FrameList';

const FrameDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { loading, schedules } = rootStore.frameStore;

  return (
    <Grid>
      <Grid.Column width={10}>
        <Segment clearing>
          <Header icon='clock' content='預託トップデッキツアー枠管理' />
          <FrameFilters />
          {loading ? (
            <LoadingComponent content='Loading...' />
          ) : (
            schedules.length > 0 && <FrameList />
          )}
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default observer(FrameDashboard);
